import styled, { css, keyframes } from "styled-components";
import { palette } from "styled-theme";

const fadein = keyframes`
from { opacity: 0; }
to   { opacity: 1; }
`;

const fadeInRule = css`
  ${fadein} 0.8s ease-in-out;
`;

const LocationWrapper = styled.div`
  .ant-dropdown-menu {
    box-shadow: none !important;
  }
  .alert-danger {
    background-color: #e74c3c;
    border-color: #e74c3c;
    color: #ffffff;
  }

  .alert-success {
    background-color: #f3ba00;
    border-color: #f3ba00;
    color: #ffffff;
    line-height: 30px;
    margin-top: 20px;
  }

  .alert {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    border-radius: 5px;
    padding: 10px;
    margin-top: 20px;
    animation: ${fadeInRule};
    strong {
      font-weight: bold;
    }
  }

  .btn {
    margin-top: 1.5rem;
  }
`;

export default LocationWrapper;
